module.exports = __webpack_public_path__ + "assets/b3801b6324be0fb17fd69ca44f8d594b.png";